import { Component, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";

const TEST_ENV_LABELS: Record<string, string> = {
  dev: "DEV",
  poc: "POC",
  uat: "UAT",
};

const DISMISSED_KEY = "stp_test_site_banner_dismissed";

@Component({
  selector: "stp-test-site-banner",
  templateUrl: "./test-site-banner.component.html",
  styleUrls: ["./test-site-banner.component.css"],
  standalone: false,
})
export class TestSiteBannerComponent implements OnInit {
  envLabel = TEST_ENV_LABELS[environment.envName];
  visible = false;

  ngOnInit(): void {
    if (
      this.envLabel &&
      sessionStorage.getItem(DISMISSED_KEY) !== this.envLabel
    ) {
      this.visible = true;
    }
  }

  dismiss(): void {
    this.visible = false;
    sessionStorage.setItem(DISMISSED_KEY, this.envLabel);
  }
}
